import { render, staticRenderFns } from "./TrainingPlan.vue?vue&type=template&id=83af6774"
import script from "./TrainingPlan.vue?vue&type=script&lang=js"
export * from "./TrainingPlan.vue?vue&type=script&lang=js"
import style0 from "./TrainingPlan.vue?vue&type=style&index=0&id=83af6774&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports